// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_Yzg","cls2":"SingularMentionCitationModal-cls2_ZfT SingularMentionCitationModal-cls1_Yzg"};